// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"n_bp","subcategoryColumn":"n_bq","articleLink":"n_br","articleCoverImage":"n_bs","articleTitle":"n_bt"};